document.addEventListener('DOMContentLoaded', (event) => {
    const popup = document.querySelector("#free-sample")
    const items = document.querySelectorAll("#free-sample .crb__content-item")

    items.forEach(item => {
        const icon = item.querySelector('.icon-wrap')

        icon.addEventListener('click', () => {
            items.forEach(each => {
                if (item != each) {
                    each.classList.add('collapsed')
                }
            });

            item.classList.toggle('collapsed')
        })
    })

    document.addEventListener('keyup', (event) => {
        if (event.key === "Escape" &&
            window.location.hash &&
            window.location.hash.length > 5) {
            window.location.hash = "#/"
        }
    }, false);

    popup.addEventListener('click', (e) => {
        const popupContent = popup.querySelector('.crb_popup-wrapper')

        if (! popupContent.contains(e.target) &&
            window.location.hash &&
            window.location.hash.length > 5) {
            window.location.hash = "#/"
        }
    })
})